import { ShieldCheck, Phone, Mail } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

/**
 * Slim premium top bar — sits above the Navbar.
 * Shows the Saudi Commercial Registration (C.R.) number + key contact info.
 * Required by KSA business registration display rules.
 */
export default function TopBar() {
  const { t } = useI18n();
  const tb = t.topbar;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[55] bg-secondary text-secondary-foreground border-b border-white/10 h-9"
      data-testid="top-bar"
    >
      <div className="container-page flex items-center justify-between h-full text-[11px] tracking-wide">
        {/* Left: C.R. number with shield icon */}
        <div className="flex items-center gap-2 sm:gap-3" data-testid="topbar-cr">
          <ShieldCheck className="h-3.5 w-3.5 text-primary shrink-0" />
          <span className="font-semibold uppercase tracking-[0.18em] text-secondary-foreground/80">
            {tb.crLabel}
          </span>
          <span className="font-bold text-primary tabular-nums tracking-[0.1em]">
            {tb.crNumber}
          </span>
          <span className="hidden lg:inline text-secondary-foreground/35">·</span>
          <span className="hidden lg:inline font-semibold uppercase tracking-[0.18em] text-secondary-foreground/55">
            VAT
          </span>
          <span className="hidden lg:inline font-bold text-primary tabular-nums tracking-[0.1em]">
            311128579800003
          </span>
          <span className="hidden md:inline text-secondary-foreground/35">·</span>
          <span className="hidden md:inline text-secondary-foreground/55">
            {tb.registered}
          </span>
        </div>

        {/* Right: contact micro-strip */}
        <div className="hidden md:flex items-center gap-5 text-secondary-foreground/65">
          <a
            href="tel:+966500338215"
            className="flex items-center gap-1.5 hover:text-primary transition-colors"
            data-testid="topbar-phone"
          >
            <Phone className="h-3 w-3" />
            <span className="tabular-nums">+966 50 033 8215</span>
          </a>
          <a
            href="mailto:m.ali@mnh-ksa.com"
            className="flex items-center gap-1.5 hover:text-primary transition-colors"
            data-testid="topbar-email"
          >
            <Mail className="h-3 w-3" />
            <span>m.ali@mnh-ksa.com</span>
          </a>
        </div>
      </div>
    </div>
  );
}
